import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, X } from "lucide-react";

/**
 * Polls the Vimeo watchlist notifications every 60s. If any entries just
 * finished downloading, shows a dismissable banner at the top of the app.
 */
export default function WatchNotificationBanner() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const r = await api.get("/vimeo-watch/notifications");
      setItems(r.data.notifications || []);
    } catch {
      // silent — not critical
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  const dismiss = async () => {
    setItems([]);
    try {
      await api.post("/vimeo-watch/notifications/ack");
    } catch {
      // silent
    }
  };

  if (items.length === 0) return null;
  const n = items.length;
  const first = items[0];

  return (
    <div
      className="bg-emerald-950/60 border-b border-emerald-800 px-4 py-2.5 flex items-center gap-3 text-sm"
      data-testid="watch-notification-banner"
    >
      <CheckCircle2 size={16} className="text-emerald-400 shrink-0" />
      <div className="flex-1 min-w-0">
        <span className="text-emerald-300 font-medium">
          {n === 1
            ? `New footage ready: ${first.event_name || first.url}`
            : `${n} watched Vimeo videos just finished — ready in your Library`}
        </span>
      </div>
      {n === 1 && first.video_id && (
        <Link
          to={`/studio/${first.video_id}`}
          onClick={dismiss}
          className="btn-secondary !py-1 !px-2 text-[10px] !border-emerald-700 !text-emerald-300 hover:!bg-emerald-600/20"
          data-testid="watch-banner-open"
        >
          Open in Studio
        </Link>
      )}
      <Link
        to="/watchlist"
        onClick={dismiss}
        className="btn-secondary !py-1 !px-2 text-[10px] !border-emerald-700 !text-emerald-300 hover:!bg-emerald-600/20"
        data-testid="watch-banner-view-all"
      >
        View watchlist
      </Link>
      <button
        onClick={dismiss}
        className="text-emerald-400 hover:text-emerald-200 shrink-0"
        title="Dismiss"
        data-testid="watch-banner-dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
